export const getNavigation = (t: any) => [
  {
    text: t('analytics'),
    icon: 'chart',
    items: [
      {
        text: t('dashboard'),
        path: '/support/dashboard',
      },
    ],
  },
  {
    text: t('tickets'),
    icon: 'comment',
    items: [
      {
        text: t('allTickets'),
        path: '/support/tickets',
      },
      {
        text: t('assignedToMe'),
        path: '/support/tickets?assignedToRef=me',
      },
      {
        text: t('unassignedTickets'),
        path: '/support/tickets?assignedToRef=0',
      },
      {
        text: t('slaRisk'),
        path: '/support/tickets?sla=risk',
      },
      {
        text: t('pendingReplies'),
        path: '/support/tickets?status=5',
      },
      {
        text: t('closedTickets'),
        path: '/support/tickets?status=passive',
      },
    ],
  },
  {
    text: t('organizations'),
    icon: 'group',
    items: [
      {
        text: t('allOrganizations'),
        path: '/support/organizations',
      },
      {
        text: t('contacts'),
        path: '/support/contacts',
      },
    ],
  },
  {
    text: t('channels'),
    icon: 'tel',
    items: [
      {
        text: t('channelPortal'),
        path: '/support/channels/portal',
      },
      {
        text: t('email'),
        path: '/support/channels/email',
      },
      {
        text: t('channelWidget'),
        path: '/support/channels/widget',
      },
      {
        text: t('channelWhatsapp'),
        path: '/support/channels/whatsapp',
      },
      {
        text: t('channelTelegram'),
        path: '/support/channels/telegram',
      },
    ],
  },
  {
    text: t('automations'),
    icon: 'box',
    items: [
      {
        text: t('workflows'),
        path: '/support/automation/workflows',
      },
      {
        text: t('rules'),
        path: '/support/automation/rules',
      },
      {
        text: t('webhooks'),
        path: '/support/automation/webhooks',
      },
      {
        text: t('n8n'),
        path: '/support/automation/n8n',
      },
    ],
  },
  {
    text: t('forms'),
    icon: 'orderedlist',
    items: [
      {
        text: t('requestForms'),
        path: '/support/forms/request-forms',
      },
      {
        text: t('fields'),
        path: '/support/forms/fields',
      },
      {
        text: t('ticketTypes'),
        path: '/support/forms/ticket-types',
      },
    ],
  },
  {
    text: t('teams'),
    icon: 'user',
    items: [
      {
        text: t('teams'),
        path: '/support/teams',
      },
      {
        text: t('users'),
        path: '/vendor-management/users',
      },
      {
        text: t('roles'),
        path: '/support/roles',
      },
    ],
  },
  {
    text: t('reports'),
    icon: 'chart',
    items: [
      {
        text: t('sla'),
        path: '/support/reports/sla',
      },
      {
        text: t('agentPerformance'),
        path: '/support/reports/agent-performance',
      },
      {
        text: t('customerSatisfaction'),
        path: '/support/surveys',
      },
      {
        text: t('ticketAnalysis'),
        path: '/support/reports/tickets',
      },
    ],
  },
  {
    text: t('messaging'),
    icon: 'message',
    items: [
      {
        text: t('internChat'),
        path: '/support/team-chat?scope=intern',
      },
      {
        text: t('personalMessages'),
        path: '/support/team-chat?scope=personal',
      },
      {
        text: t('groupChats'),
        path: '/support/team-chat?scope=group',
      },
      {
        text: t('companyChats'),
        path: '/support/team-chat?scope=company',
      },
    ],
  },
  {
    text: t('settings'),
    icon: 'preferences',
    items: [
      {
        text: t('generalSettings'),
        path: '/settings/general',
      },
      {
        text: t('themes'),
        path: '/settings/theme',
      },
      {
        text: t('products'),
        path: '/support/products',
      },
      {
        text: t('canned-responses'),
        path: '/support/canned-responses',
      },
      {
        text: t('integrations'),
        path: '/settings/integrations',
      },
      {
        text: t('logs'),
        path: '/support/logs',
      },
    ],
  },
  {
    text: 'Logo',
    icon: 'box',
    items: [
      { text: t('logoCustomers'), path: '/logo/customers' },
      { text: t('logoMaterials'), path: '/logo/materials' },
      { text: t('logoSuppliers'), path: '/logo/suppliers' },
      { text: t('logoSalesPrices'), path: '/logo/sales-prices' },
      { text: t('logoPurchasePrices'), path: '/logo/purchase-prices' },
      { text: t('logoWarehouseParams'), path: '/logo/warehouse-params' },
      { text: t('logoOrders'), path: '/logo/orders' },
    ],
  },
];
